"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankedQuestionModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class RankedQuestionModule extends base_1.InputModule {
    constructor(_a) {
        var { displayOrder = "desc", rankLow, rankHigh, rankRange } = _a, rest = __rest(_a, ["displayOrder", "rankLow", "rankHigh", "rankRange"]);
        super(rest);
        this._type = "RankedQuestion";
        if (rankRange !== 5 && rankRange !== 10) {
            throw new Error("ranked questions rankRange accepts values of 5 or 10");
        }
        this.displayOrder = displayOrder;
        this.rankLow = rankLow;
        this.rankHigh = rankHigh;
        this._rankRange = rankRange;
    }
    get rankRange() {
        return this._rankRange;
    }
    set rankRange(rankRange) {
        if (rankRange !== 5 && rankRange !== 10) {
            throw new Error("ranked questions rankRange accepts values of 5 or 10");
        }
        this._rankRange = rankRange;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                actionRequired: this.actionRequired,
                id: this.id,
                noBorder: this.noBorder,
                rankLow: this.rankLow,
                rankHigh: this.rankHigh,
                rankRange: this.rankRange,
                label: this.label,
                required: this.required,
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        if (this.validate()) {
            const _b = this.toBuilderConfig(), { required, label, rankLow, rankHigh } = _b, base = __rest(_b, ["required", "label", "rankLow", "rankHigh"]);
            const surveyConfigModule = Object.assign(Object.assign({}, base), { actionRequired: this.actionRequired, header: { children: (_a = label[this.languageCode]) !== null && _a !== void 0 ? _a : "" }, rankLow: rankLow[this.languageCode], rankHigh: rankHigh[this.languageCode], noBorder: this.noBorder });
            if (required) {
                surveyConfigModule.validation = (0, util_1.addRequiredValidation)();
            }
            return surveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        var _a, _b, _c;
        return {
            id: this.id,
            type: this.type,
            rank: {
                low: (_a = this.rankLow[this.languageCode]) !== null && _a !== void 0 ? _a : "",
                high: (_b = this.rankHigh[this.languageCode]) !== null && _b !== void 0 ? _b : "",
                range: this.rankRange,
            },
            question: (_c = this.label[this.languageCode]) !== null && _c !== void 0 ? _c : "",
            actionRequired: this.actionRequired,
        };
    }
}
exports.RankedQuestionModule = RankedQuestionModule;
//# sourceMappingURL=RankedQuestion.js.map